import React from "react";

// css
import "./buttonStyles.css";

const AdminBrandButton = ({
  title,
  onClick,
  bgColorPrimary,
  style,
  type = "button",
}) => {
  if (!bgColorPrimary) {
    return (
      <button
        className="brand-button-invert"
        onClick={onClick}
        style={style}
        type={type}
      >
        {title}
      </button>
    );
  }
  return (
    <button
      className="brand-button "
      onClick={onClick}
      style={style}
      type={type}
    >
      {title}
    </button>
  );
};

export default AdminBrandButton;
